import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModelGroup} from '../data/ModelGroup';
import {ModelsDataProvider} from '../data/ModelsDataProvider';
import {MatStepper } from '@angular/material/stepper';
import {SimulationSession} from '../data/SimulationSession';
import {SimulationSessionProvider} from '../data/SimulationSessionProvider';
import {Router} from '@angular/router';


@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepperComponent implements OnInit, AfterViewInit {

  private currentStep = 0;
  public simulationSession!: SimulationSession;

  @ViewChild('stepper', {static: true}) private myStepper!: MatStepper;

  isLinear = false;
  firstFormGroup: FormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required]
  });
  secondFormGroup: FormGroup = this.formBuilder.group({
    secondCtrl: ['', Validators.required]
  });

  constructor(private formBuilder: FormBuilder, private modelsDataProvider: ModelsDataProvider, private simulationSessionProvider: SimulationSessionProvider, private router: Router) {
    // console.log(this.router.getCurrentNavigation().extras.state.example); // should log out 'bar'
    const navigation = this.router.getCurrentNavigation();
    if (navigation) {
      const state = navigation.extras.state as {
        step: number
      };
      if (state && state.step) {
        this.currentStep = state.step;
      }
    }
  }

  ngOnInit(): void {
    this.simulationSession = this.simulationSessionProvider.getSimulationSession();
    this.myStepper.selectedIndex = this.currentStep;
  }

  ngAfterViewInit(): void {
    // outputs `I am span`
    console.log(this.myStepper);
  }

  changeSimulationSession(simSess: SimulationSession) {
    this.simulationSession = simSess;
  }

  public leftButtonClicked() {
    console.log('back');
    this.goBack(this.myStepper);
  }

  public rightButtonClicked() {
    console.log('next');
    this.goNext(this.myStepper);
  }

  goNext(stepper: MatStepper) {
    stepper.next();
  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }
}
